import { Injectable } from '@angular/core';
import { NomeTela } from '../constants/mixpanel-events.const';

@Injectable({
  providedIn: 'root',
})
export class RouteMapperUtils {
  private readonly routeMap: { pattern: RegExp | string; name: string }[] = [
    { pattern: '/proposta/criar', name: NomeTela.CRIAR_PROPOSTA },
    { pattern: /\/proposta\/editar\/.+/, name: NomeTela.EDITAR_PROPOSTA },
    { pattern: '/proposta', name: NomeTela.LISTA_PROPOSTAS },
    { pattern: '/login', name: NomeTela.TELA_LOGIN },
    { pattern: '/auth/callback', name: NomeTela.CALLBACK_AUTENTICACAO },
  ];

  getNomeTela(url: string, routePath?: string | null): string {
    for (const mapping of this.routeMap) {
      if (typeof mapping.pattern === 'string') {
        if (url.includes(mapping.pattern)) {
          return mapping.name;
        }
      } else {
        if (mapping.pattern.test(url)) {
          return mapping.name;
        }
      }
    }
    if (routePath) {
      return this.formatRoutePath(routePath);
    }

    return NomeTela.TELA_DESCONHECIDA;
  }

  private formatRoutePath(routePath: string): string {
    return routePath
      .split('/')
      .filter(Boolean)
      .map(segment => segment.charAt(0).toUpperCase() + segment.slice(1))
      .join(' ');
  }
}
